const contentData = {
  generic: {
    free: {
      'en-us': 'FREE',
    },
  },
  geo: {
    linkLabel: 'See our mattresses in store',
    message: 'Near Phoenix, Arizona?',
    linkUrl: {
      href: 'https://go.birchliving.com/showroom-partners',
      title: 'See our mattresses in store',
    },
  },
  cart: {
    emptyTextLine1: {
      'en-us': 'Your cart is empty.',
    },
    emptyTextLine2: {
      'en-us': 'Better rest awaits.',
    },
    telephoneText: {
      'en-us': 'Questions? Call: 1-833-217-3525',
    },
    telephoneValue: {
      'en-us': '1833-217-3525',
    },
    telephoneLinkTitle: {
      'en-us': 'Contact Birch Living Customer Service',   
    },
    closeButton: {
      'en-us': 'Close',
    },
    cartTitle: {
      'en-us': 'Your Cart',
    },
    subtotal: {
      'en-us': 'Subtotal',
    },
    taxes: {
      'en-us': 'Taxes',
    },
    shipping: {
      'en-us': 'Estimated Shipping',
    },
    calculatedShipping: {
      'en-us': 'Calculated at checkout',
    },
    checkout: {
      'en-us': 'Secure Checkout',
    },
    trashCanAriaLabel: {
      'en-us': 'Remove [QUANTITY] [ITEM] from cart',
    },
  },
  og: {
    image: {
      url: {
        'en-US': '/images/leesa-og-default.jpg',
      },
    },
  },
  skipLink: {
    skipATCButton: {
      'en-us': 'Skip to Add to Cart',
    },
    skipToCart: {
      'en-us': 'Skip to Cart',
    },
    skipToCO: {
      'en-us': 'Skip to Checkout',
    },
    skipToContent: {
      'en-us': 'Skip to Content',
    },
  },
  'en-US': {
    atc: {
      'aria-label': 'Add [SIZE] size [TITLE] to cart for $[PRICE]',
      'aria-label-no-stock': 'Sorry, this product is out of stock',
      'label-default': 'Add to cart',
      'label-multiple': 'Add [QTY] items to cart',
      'label-no-stock': 'Out of Stock',
      name: 'Add',
      'name-no-stock': 'Sold',
      'name-event': 'Adding',
      event: 'Adding',
    },
    oos: {
      singleProductMsg:
        'Sorry, the following item has become out of stock and has been removed from your cart:',
      multiProductMsg:
        'Sorry, the following items have become out of stock and have been removed from your cart:',
    },
  },
};
export default contentData;

export const defaultSort = {
  title: 'Relevance',
  slug: null,
  sortKey: 'RELEVANCE',
  reverse: false,
};

export const sorting = [
  defaultSort,
  {
    title: 'Trending',
    slug: 'trending-desc',
    sortKey: 'BEST_SELLING',
    reverse: false,
  }, // asc
  {
    title: 'Latest arrivals',
    slug: 'latest-desc',
    sortKey: 'CREATED_AT',
    reverse: true,
  },
  {
    title: 'Price: Low to high',
    slug: 'price-asc',
    sortKey: 'PRICE',
    reverse: false,
  }, // asc
  {
    title: 'Price: High to low',
    slug: 'price-desc',
    sortKey: 'PRICE',
    reverse: true,
  },
];


export const HIDDEN_PRODUCT_TAG = 'nextjs-frontend-hidden';
export const DEFAULT_OPTION = 'Default Title';
export const SHOPIFY_GRAPHQL_API_ENDPOINT = `/api/${process.env.SHOPIFY_STOREFRONT_API_VERSION}/graphql.json`;

export const companyInformation = {
  name: 'Birch Living',
  url: 'https://birchliving.com',
  logo: 'https://birchliving.com/images/logo-birch.svg',
  address: {
    streetAddress: '5301 W Bethany Home Rd',
    addressLocality: 'Glendale',
    addressRegion: 'AZ',
    addressCountry: 'US',
    postalCode: '85301',
    telephone: '+1-917-540-5525',
  },
  contactPoint: {
    telephone: '+1-917-540-5525',
    contactType: 'Customer Service',
    email: 'support@birchliving.com',
  },
};

export const FALLBACK_SITE_NAME = companyInformation.name;

export const FALLBACK_METADATA_TITLE =
  'Birch Living | Mattresses Designed For Every Body - Birch Living';

export const FALLBACK_METADATA_DESCRIPTION =
  'Shop Birch Living\'s mattresses. Outrageous comfort designed for every body. Take our 30-second sleep quiz to find out which mattress is right for you.';

export const FALLBACK_OG_IMAGE_URL = '/logo-birch.svg';

export const idMe = {
  shopUrl: 'https://groups.id.me/',
  aboutUrl: 'https://www.id.me/about',
};
